import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { STAYS } from "@/data/content";

export default function StaySpotlight() {
  return (
    <section data-testid="stays-preview" className="bg-white/70 border-y border-slateblue/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <Eyebrow>Stays</Eyebrow>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-navy max-w-xl leading-tight">
              Find a stay worth checking into
            </h2>
            <p className="mt-4 text-base text-charcoal/75 max-w-xl leading-relaxed">
              Hotel roundups and comparisons organized by location, traveler type, amenities, and value — not
              just star rating.
            </p>
          </div>
          <Link
            to="/stays"
            data-testid="stays-view-all"
            className="group inline-flex items-center gap-2 text-sm font-semibold text-navy hover:text-gold transition-colors duration-300 shrink-0"
          >
            Browse all stays
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STAYS.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.08}>
              <article
                data-testid={`stay-card-${s.slug}`}
                className="group h-full rounded-3xl bg-white border border-slateblue/15 overflow-hidden transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_-16px_rgba(16,42,67,0.18)] hover:border-gold/40"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
                  />
                  <span className="absolute top-4 left-4 rounded-full bg-ivory/90 backdrop-blur px-3.5 py-1.5 text-[10px] font-semibold tracking-[0.16em] uppercase text-navy">
                    {s.category}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between gap-3">
                    <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-slateblue">{s.location}</p>
                    <p className="text-xs font-semibold text-gold whitespace-nowrap">{s.price}</p>
                  </div>
                  <h3 className="mt-3 font-serif text-xl text-navy leading-snug">{s.title}</h3>
                  <p className="mt-3 text-sm text-charcoal/70 leading-relaxed">{s.why}</p>
                  <a
                    href={s.booking}
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    data-testid={`stay-booking-${s.slug}`}
                    className="mt-5 inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.14em] uppercase text-ocean hover:text-gold transition-colors duration-300"
                  >
                    Check current availability
                    <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
